import { render } from "./UsuarioList.vue?vue&type=template&id=35e60406"
import script from "./UsuarioList.vue?vue&type=script&lang=js"
export * from "./UsuarioList.vue?vue&type=script&lang=js"

import exportComponent from "C:\\hd\\git\\enuve\\app-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__